<template>
  <header  :class="flag?top>0?'headerBgLeave':'headerBgEnter':'animated bounceInDown'">
      <div class="logo">
           <router-link to="/">
            <img :src="isIndex?require('@/assets/navLogo.png'):top>0?require('@/assets/navLogo.png'):require('@/assets/navLogo1.png')" alt="logo"  height="32">
           </router-link>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            text-color="#333"
            activeTextColor="#fff"
          >
            <el-menu-item index="1">
              <router-link to="/" :class="isIndex?'':top>0?'':'whiteFont'">
                  首页
              </router-link>
            </el-menu-item>
            <el-menu-item index="2">
                <el-popover
                  placement="bottom"
                  v-model="productsFlag"
                  width="1200"
                  trigger="hover">
                  <div class="select productsSelect">
                    <div v-for="(item,index) in productsNav" class="productsNav" :key="index">
                        <div>
                          <router-link to="/products/qxzn" class="navTitle" style="text-decoration: none;" v-if="index==0">
                            {{item.name}}
                          </router-link>
                          <router-link to="/products/cellNew" class="navTitle" style="text-decoration: none;" v-else-if="index==1">
                            {{item.name}}
                          </router-link>
                          <span v-else class="navTitle">{{item.name}}</span>
                          </div>
                        <div class="navList">
                            <div v-for="list in item.list" >
                              <router-link :to="list.src" v-if="list.allow" >{{list.title}}</router-link>
                              <router-link  to="/products/tissueBank" v-else class="no_allow">{{list.title}} </router-link>
                            </div>
                        </div>
                    </div>
                  </div>
                  <el-button slot="reference">
                      <router-link to="/products/qxzn" :class="isIndex?'':top>0?'':'whiteFont'">
                          样本库
                      </router-link>
                  </el-button>
                </el-popover>
            </el-menu-item>
            <el-menu-item index="3">
                <el-popover
                  placement="bottom"
                  width="1200"
                  v-model="databaseFlag"
                  trigger="hover">
                  <div class="select productsSelect">
                    <div v-for="item in databaseNav" class="productsNav">
                        <div class="navTitle">{{item.name}}</div>
                        <div class="navList">
                            <div v-for="list in item.list">
                              <router-link :to="list.src" v-if="list.allow" >{{list.title}}</router-link>
                              <router-link  to="/database/bioOmics" v-else class="no_allow">{{list.title}} </router-link>
                            </div>
                        </div>
                    </div>
                  </div>
                  <el-button slot="reference">
                      <router-link to="/database/bioOmics" :class="isIndex?'':top>0?'':'whiteFont'">
                          数据库
                      </router-link>
                  </el-button>
                </el-popover>
            </el-menu-item>
            <el-menu-item index="4">
                <el-popover
                  placement="bottom"
                  width="1200"
                  v-model="knowledgeFlag"
                  trigger="hover">
                  <div class="select productsSelect">
                    <div v-for="item in knowledgeNav" class="productsNav">
                        <div class="navTitle">{{item.name}}</div>
                        <div class="navList">
                            <div v-for="list in item.list">
                              <router-link :to="list.src" v-if="list.allow" >{{list.title}}</router-link>
                              <router-link  to="/knowledge/special" v-else class="no_allow">{{list.title}} </router-link>
                            </div>
                        </div>
                    </div>
                  </div>
                  <el-button slot="reference">
                      <router-link to="/knowledge/special" :class="isIndex?'':top>0?'':'whiteFont'">
                          知识库
                      </router-link>
                  </el-button>
                </el-popover>
            </el-menu-item>
            <el-menu-item index="5">
              <router-link to="/about/academic" :class="isIndex?'':top>0?'':'whiteFont'">
                  学术科研
              </router-link>
            </el-menu-item>
            <el-submenu index="6">
                <template slot="title"><div :class="isIndex?'':top>0?'':'whiteFont'">合作案例</div></template>
                <el-menu-item index="6-1"><router-link to="/case/hospital">医疗机构合作案例</router-link></el-menu-item>
                <el-menu-item index="6-2"><router-link to="/case/institution">科研院所合作案例</router-link></el-menu-item>
                <el-menu-item index="6-3"><router-link to="/case/company">研发企业合作案例</router-link></el-menu-item>
            </el-submenu>
            <el-submenu index="7" popper-class="popperNav">
                <template slot="title"><div :class="isIndex?'':top>0?'':'whiteFont'">关于我们</div></template>
                <el-menu-item index="7-1"><router-link to="/about/introduction">公司简介</router-link></el-menu-item>
                <el-menu-item index="7-2"><router-link to="/about/news">新闻报道</router-link></el-menu-item>
                <el-menu-item index="7-3"><router-link to="/about/position">热招职位</router-link></el-menu-item>
                <el-menu-item index="7-4"><router-link to="/about/contact">联系我们</router-link></el-menu-item>
            </el-submenu>
          </el-menu>
          <div class="tel">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="margin: 0 2px;">&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style="margin: 0 px;">&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-search" style="margin-left: 4px;"></i>
          </div>
      </div>
<!--      <div class="select productsSelect" :style="{display:productsFlag?'true':'false'}">-->
<!--        <div class="top"><i class="el-icon-caret-top"></i></div>-->
<!--        <div v-for="item in productsNav" class="productsNav">-->
<!--            <div class="navTitle">{{item.name}}</div>-->
<!--            <div class="navList">-->
<!--                <div v-for="list in item.list"><router-link :to="list.src" >{{list.title}}</router-link></div>-->
<!--            </div>-->
<!--        </div>-->
<!--      </div>-->
  </header>
</template>

<script>
export default {
  name:'layoutNav',
  data () {
    return {
      activeIndex:'1',
      top:0,
      flag:false,
      isIndex:true,
      routeList:[
          '/home','products','products1','products2','products3','case','about'
      ],
      routeList1:[
          {
              path:'/home',
              index:'1'
          },
          {
              path:'/products/tissueBank',
              index:'2-1'
          },
          {
              path:'/products/specialBank',
              index:'2-2'
          },
          {
              path:'/products/dataCollection',
              index:'2-3'
          },
          {
              path:'/products/transport',
              index:'2-4'
          },
          {
              path:'/products/share',
              index:'2-5'
          },
          {
              path:'/products/queue',
              index:'2-6'
          },
          {
              path:'/products/operation',
              index:'2-7'
          },
          {
              path:'/products/equipment',
              index:'2-8'
          },
          {
              path:'/products/service',
              index:'2-9'
          },
          {
              path:'/products/download',
              index:'2-10'
          },

      ],
      productsNav:[
          {
            name:'EH-IBS生物样本库数字化智能全息解决方案',
            list:[
                {
                  title:'BioFactory临床数据与样本资源库管理系统',
                  src:'/products/tissueBank',
                  allow:true
                },
                {
                  title:'MicrobioBank菌株库管理系统',
                  src:'/products/specialBank',
                  allow:false
                },
                {
                  title:'BioData数据采集系统',
                  src:'/products/dataCollection',
                  allow:false
                },
                {
                  title:'BioMonitor生物资源运输监控管理平台',
                  src:'/products/transport',
                  allow:true
                },
                {
                  title:'BioCloud多中心生物样本资源共享平台',
                  src:'/products/share',
                  allow:true
                },
                {
                  title:'BioCohort自然人群队列研究管理平台',
                  src:'/products/bioCohort',
                  allow:false
                },
                {
                  title:'BioVision生物样本库数字孪生可视化大屏展示',
                  src:'/products/bioVision',
                  allow:true
                },
                // {
                //   title:'人类遗传资源管理行政审批服务',
                //   src:'/products/examine',
                //   allow:true
                // },
                {
                  title:'ISO20387技术咨询服务',
                  src:'/products/iso',
                  allow:true
                },
                {
                  title:'设备/耗材选型咨询服务',
                  src:'/products/equipment',
                  allow:false
                },
                {
                  title:'场地布局规划咨询',
                  src:'/products/site',
                  allow:true
                },
                {
                  title:'生物样本库其他服务',
                  src:'/products/service',
                  allow:true
                },
                {
                  title:'生物样本库资料下载',
                  src:'/products/download',
                  allow:true
                }
            ]
          },
          {
            name:'EH-CLCMS细胞全生命周期整体解决方案',
            list:[
                {
                  title:'Ecell细胞全生命周期信息管理系统',
                  src:'/products/eCell',
                  allow:true
                },
                {
                  title:'Cellcollect细胞采集系统',
                  src:'/products/cellData',
                  allow:false
                },
                {
                  title:'CellSelect细胞筛查系统',
                  src:'/products/screen',
                  allow:false
                },
                {
                  title:'CellCustomer储户CRM管理系统',
                  src:'/products/stomer',
                  allow:false
                },
                {
                  title:'CellMonitor细胞资源运输监控管理平台',
                  src:'/products/cellMonitor',
                  allow:false
                },
                {
                  title:'CellData细胞资源大数据管理平台',
                  src:'/products/cellCloud',
                  allow:false
                },
                {
                  title:'CellVision细胞资源库数字孪生大屏可视化系统',
                  src:'/products/cellVision',
                  allow:false
                },
                // {
                //   title:'AABB认证咨询培训服务',
                //   src:'/products/aabb',
                //   allow:true
                // },
                // {
                //   title:'GMP标准认证培训服务',
                //   src:'/products/gmp',
                //   allow:true
                // },
                {
                  title:'设备/耗材选型咨询服务',
                  src:'/products/cellEquipment',
                  allow:false
                },
                {
                  title:'场地布局规划咨询',
                  src:'/products/cellVenue',
                  allow:true
                },
                {
                  title:'细胞资源库资料下载',
                  src:'',
                  allow:false
                }
            ]
          },
          {
            name:'EH-ILS实验室整体规划设计解决方案',
            list:[
                {
                  title:'eQuip实验室耗材数字化管理系统',
                  src:'/products/eQuip',
                  allow:false
                },
                {
                  title:'HazardHub危险化学品管理系统',
                  src:'/products/proHazard',
                  allow:false
                },
                {
                  title:'iLab智慧实验室管理系统',
                  src:'/products/iLab',
                  allow:true
                },
                {
                  title:'aniManus动物实验室管理系统',
                  src:'/products/aniManus',
                  allow:false
                },
                {
                  title:'EnviroMonitor实验室温湿度监控系统',
                  src:'/products/iMonitor',
                  allow:false
                },
                {
                  title:'Safeadom实验室环境安全智慧管理系统',
                  src:'/products/enViron',
                  allow:false
                },
                {
                  title:'labVision实验室数字孪生大屏可视化系统',
                  src:'/products/labVison',
                  allow:false
                },
                // {
                //   title:'ISO15189咨询培训服务',
                //   src:'/products/iso15189',
                //   allow:false
                // },
                // {
                //   title:'CNAS咨询培训服务',
                //   src:'/products/cnas',
                //   allow:false
                // },
                // {
                //   title:'GLP咨询培训服务',
                //   src:'/products/glp',
                //   allow:false
                // },
                {
                  title:'设备/耗材选型咨询服务',
                  src:'/products/limsEquipment',
                  allow:false
                },
                {
                  title:'场地布局规划咨询',
                  src:'/products/limsVenue',
                  allow:false
                },
                {
                  title:'实验室资料下载',
                  src:'/products/limsDownload',
                  allow:false
                }
            ]
          }
      ],
      databaseNav:[
          {
            name:'EH-ODS组学数据整合平台解决方案',
            list:[
                {
                  title:'BioOmics组学数据发布管理平台',
                  src:'/database/bioOmics',
                  allow:true
                },
                {
                  title:'PrivaCore基础隐私计算平台',
                  src:'/database/privaCore',
                  allow:false
                },
                {
                  title:'BioAnalyst生物信息集成分析平台',
                  src:'/database/bioAnalyst',
                  allow:false
                },
                {
                  title:'SciAnalyst科研分析平台',
                  src:'/database/sciAnalyst',
                  allow:false
                },
                {
                  title:'OmicsVison组学数据数字孪生大屏可视化系统',
                  src:'/database/omicsVison',
                  allow:false
                },
                {
                  title:'高性能计算存储平台',
                  src:'/database/odsStorage',
                  allow:false
                },
                {
                  title:'组学数据整合平台相关服务',
                  src:'/database/odsService',
                  allow:false
                },
                {
                  title:'组学数据整合平台资料下载',
                  src:'/database/odsDownload',
                  allow:false
                }
            ]
          },
          {
            name:'EH-CDS临床数据整合平台解决方案',
            list:[
                {
                  title:'HoloData智能专病数据管理平台',
                  src:'/database/holoData',
                  allow:true
                },
                {
                  title:'ClinData临床科研数据管理平台',
                  src:'/database/dataLink',
                  allow:false
                },
                {
                  title:'ClinTrace临床研究随访管理系统',
                  src:'/database/clinTrace',
                  allow:false
                },
                {
                  title:'ClinAnalyst临床数据分析管理平台',
                  src:'/database/clinAnalyst',
                  allow:false
                },
                {
                  title:'ClinTrial临床试验管理系统',
                  src:'/database/clinTrial',
                  allow:false
                },
                {
                  title:'ClinProject临床试验项目管理系统',
                  src:'/database/clinProject',
                  allow:false
                },
                {
                  title:'DigiCohort专病队列研究管理平台',
                  src:'/database/digiCohort',
                  allow:false
                },
                {
                  title:'SciSmart科研项目管理平台',
                  src:'/database/sciSmart',
                  allow:true
                },
                {
                  title:'ClinVision临床数据数字孪生大屏可视化系统 ',
                  src:'/database/clinVison',
                  allow:false
                },
                {
                  title:'高性能计算存储平台',
                  src:'/database/cdsStorage',
                  allow:false
                },
                {
                  title:'临床数据整合平台相关服务',
                  src:'/database/cdsService',
                  allow:false
                },
                {
                  title:'临床数据整合平台资料下载',
                  src:'/database/cdsDownload',
                  allow:false
                }
            ]
          },
     ],
      knowledgeNav:[
          {
            name:'EH-PMS精准医学知识库整体解决方案',
            list:[
                {
                  title:'BioTank专病精准医学知识图谱系统',
                  src:'/knowledge/special',
                  allow:true
                },
                {
                  title:'iRare罕见病与知识库检索分析系统',
                  src:'/knowledge/rare',
                  allow:true
                },
                {
                  title:'SciLedge科研知识管理系统',
                  src:'/knowledge/scientific',
                  allow:false
                },
                {
                  title:'Achieve靶向药筛管理平台',
                  src:'/knowledge/targeting',
                  allow:false
                },
                {
                  title:'Extreme科研一体化大数据平台',
                  src:'/knowledge/extreme',
                  allow:false
                },
                {
                  title:'PreVision精准医学知识库数字孪生大屏可视化系统',
                  src:'/knowledge/data',
                  allow:false
                },
                {
                  title:'高性能计算存储平台',
                  src:'/knowledge/storage',
                  allow:false
                },
                {
                  title:'精准医学知识库相关服务',
                  src:'/knowledge/service',
                  allow:false
                },
                {
                  title:'精准医学知识库资料下载',
                  src:'/knowledge/download',
                  allow:false
                },
            ]
          },
     ],
      productsFlag:false,
      databaseFlag:false,
      knowledgeFlag:false,
    }
  },
  watch:{
    $route(to,from){
      document.body.scrollTop= 0;
      this.productsFlag = false
      this.databaseFlag = false
      this.knowledgeFlag = false
      if (to.path === '/'){
          this.activeIndex = '1'
          this.isIndex = true
      }else if (to.path.indexOf('products') > -1){
          this.activeIndex = '2'
          this.isIndex = false
      }else if (to.path.indexOf('database') > -1){
          this.activeIndex = '3'
          this.isIndex = false
      }else if (to.path.indexOf('knowledge') > -1){
          this.activeIndex = '4'
          this.isIndex = false
      }else if (to.path.indexOf('academic') > -1){
          this.activeIndex = '5'
          this.isIndex = false
      }else if (to.path.indexOf('case') > -1){
          this.activeIndex = '6'
          this.isIndex = false
      }else{
          this.activeIndex = '7'
          this.isIndex = false
      }
    }
  },
  mounted() {
    // 监听滚动事件
      window.addEventListener('scroll', this.handleScroll, true)
  },
  methods:{
    handleScroll(){
      let top = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset)
      if(top > 0){
          this.flag = true
      }
      this.top = top
    },
    handleSelect(){

    },
  }
}
</script>

<style lang="less" scoped>
    .headerBgLeave{
        animation: navLeave 1s infinite;
        animation-fill-mode:forwards;
        animation-iteration-count:1;
    }
    @keyframes navLeave {
        0%{
            background: none;
        }
        100%{
            background:rgb(255, 255, 255);
            box-shadow: 0 2px 10px rgba(237,28,36,1);
        }
    }
    .headerBgEnter{
        animation: navEnter 1s infinite;
        animation-fill-mode:forwards;
        animation-iteration-count:1;
    }
    @keyframes navEnter {
        0%{
            background:rgb(255, 255, 255);
        }
        100%{
            background: none;
        }
    }
    /deep/
    .el-menu-item *{
        vertical-align: bottom;
    }
    header{
        width: 100%;
        height: 48px;
        padding: 0;
        margin: 0;
        position: fixed;
        top: 0;
        z-index: 9999999;
        background: none;
        --animate-delay: 2s;
        div.logo{
            width: 1180px;
            height: 48px;
            margin: 0 auto;
            padding-right: 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            .el-menu.el-menu--horizontal{
              border-bottom: none;
              margin-left: 20px;
              background: none;
              .el-menu-item{
                height: 48px;
                line-height: 48px;
                font-size: 17px;
                letter-spacing: 1px;
                /*border-color:#ed1c24;*/
                padding: 0;
                  border:none!important;
                /*border-radius: 0 0 30px 30px;*/

                .el-button{
                    width: auto;
                    height: 48px;
                    line-height: 48px;
                    border: none;
                    padding: 0;
                    margin: 0;
                    background: none;
                    font-size: 17px;
                    letter-spacing: 1px;
                }
                a{
                  display: block;
                  width: 100%;
                  height: 48px;
                  line-height: 48px;
                  text-decoration: none;
                  padding: 0 25px;
                  box-sizing: border-box;
                }
                .whiteFont{
                    color: #fff;
                }
                .whiteFont:hover{
                    color: #333;
                }
              }
              .el-submenu.is-active{
                background: #ed1c24;
                .el-button{
                    background: #ed1c24;
                    color: #fff!important;
                }
              }
              .el-menu-item.is-active{
                /*background: radial-gradient(#ed1c24);*/
                background: #ed1c24;
                  .el-button{
                    background: #ed1c24;
                    color: #fff!important;
                      &>span>a{
                          color: #fff!important;
                      }
                }
              }

            }
            .tel{
              width: 142px;
              height: 22px;
              line-height: 20px;
              border: 1px solid #999;
              background: #fff;
              color: #a8a8a8;
              border-radius: 20px;
              box-sizing: border-box;
              // padding: 0 1px 0 16px;
              text-align: center;
              letter-spacing: 1px;
              font-size: 12px;
              font-family: "E";
            }
        }
    }
    /deep/
    .el-menu--horizontal>.el-submenu .el-submenu__title{
        height: 48px;
        line-height: 48px;
        font-size: 17px;
        letter-spacing: 1px;
          display: block;
          width: 100%;
          text-decoration: none;
          padding: 0 25px;
          border:none!important;
        i{
            display: none;
        }
        &>hover{
            background: #fff;
        }
    }
    .el-menu--popup{
        padding: 0!important;
        li{
            padding: 0!important;
            a{
                display: block;
                width: 100%;
                height: 100%;
                text-decoration: none;
                padding: 0 10px;
                /*background: #ed1c24;*/
                box-sizing: border-box;
                /*color: #fff;*/
            }
        }
        li:hover{
            background: #ed1c24;
            a{
                color: #fff;
            }
        }
        .is-active{
            background: #ed1c24;
            color: #fff;
            a{
                background: #ed1c24;
                color: #fff;
            }
        }
    }
    /deep/
    .is-active:hover{
        color: #fff!important;
        background: #ed1c24!important;
        div{
            color: #333!important;
            background: #ed1c24!important;
        }
    }
    .whiteFont{
        color: #fff;
    }
    .whiteFont:hover{
        color: #333!important;
    }
    /deep/
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
        div{
            color: #fff;
        }

    }
    .select{
        background: #fff;
        width: 100%;
        box-sizing: border-box;
        padding:0 20px 20px;
        .top{
            position: absolute;
            top: -27px;
            left: 36%;
            i{
                color: #fff;
                font-size: 40px;
            }
        }
    }
    .productsSelect{
        .top{
            left: 36%;
        }
        .productsNav{
            .navTitle{
                color: #006efd;
                font-size: 22px;
                font-weight: bold;
                margin-left: 10px;
                margin-top: 20px;
            }
            .navList{
                display: flex;
                flex-wrap: wrap;
                /*margin-top: 10px;*/
                div{
                    width: 31%;
                    margin: 10px;
                    height: 18px;
                    a{
                        text-decoration: none;
                        font-size: 16px;
                        &:hover{
                          color: #006efd;
                            /*font-size: 18px;*/
                        }
                    }
                }

            }
        }
    }
    .no_allow{
      cursor: not-allowed;
    }
</style>
